import Context from '@/api/models/Context';
import LanguageService from '@/services/LanguageService';
import { defineStore } from 'pinia';

export const useContextStore = defineStore('context', {
  state: () => ({
    lang: 'pt',
    countriesList: [],
    requestedRoute: null,
    requestedRouteParams: {},
    ignoreIncomingRoute: false,

    isLanguageModalOpen: false
  }),
  actions: {
    setLang(lang) {
      const avaliable = ['pt', 'en', 'es'];
      this.lang = avaliable.includes(lang) ? lang : 'pt';
    },
    setCountriesList(list) {
      this.countriesList = list;
    },
    saveRequestedRoute(uri, params) {
      if (this.ignoreIncomingRoute) {
        return;
      }

      this.requestedRoute = uri;
      this.requestedRouteParams = params;
    },
    saveIgnoreIncomingRoute(ignore = true) {
      this.ignoreIncomingRoute = ignore ? true : false;
    },

    // Language Modal
    openLanguageModal() {
      this.isLanguageModalOpen = true; 
    },
    closeLanguageModal() {
      this.isLanguageModalOpen = false; 
    },

    gatherContext(reload = false) {
      if (this.context == null || reload == true) {
        this.context = new Context();
      }
    },
  },
  getters: {
    getLang: (state) => state.lang,
    getCountries: (state) => state.countriesList,
    getnavigatorLanguage: (state) => {
      const langs = {
        en: 'en-US',
        pt: 'pt-BR',
        es: 'es-ES'
      }

      return langs[state.lang];
    },

    getRequestedRoute: (state) => state.requestedRoute,
    getRequestedRouteParams: (state) => state.requestedRouteParams,

    getLanguages: () => LanguageService.getLanguages('code'),
    getLangObject: (state) => {
      const langs = LanguageService.getLanguages('code');
      return langs.get(state.lang).getValue();
    },
    companyNickname: () => process.env.VUE_APP_COMPANY_NICKNAME || '',
    companyName: () => (process.env.VUE_APP_COMPANY_NAME || '').toLocaleUpperCase(),
    companyCNPJ: () => process.env.VUE_APP_COMPANY_CNPJ || '',
    supportEmail: () => process.env.VUE_APP_SUPPORT_EMAIL || '',
    appVersion: () => process.env.VUE_APP_VERSION || '',
    appCreator: () => process.env.VUE_APP_APLICATION_CREATOR || '',
    appCreatorUrl: () => process.env.VUE_APP_APLICATION_CREATOR_URL || ''
  }
})
